export const hdmgdjSteps = [
  {
    id: "s-1",
    no: "01",
    icon: "ri-download-2-line",
    title: "下载安装",
    desc: "选择手机或电脑对应的系统版本，一键获取黄豆魔改短剧安装包。",
  },
  {
    id: "s-2",
    no: "02",
    icon: "ri-search-eye-line",
    title: "挑选剧目",
    desc: "题材分类、热门榜单、心动专题多路发现，几秒就找到想看的。",
  },
  {
    id: "s-3",
    no: "03",
    icon: "ri-bookmark-3-line",
    title: "加入追剧",
    desc: "一键收藏并云端同步，换设备登录也能回到上次的进度。",
  },
  {
    id: "s-4",
    no: "04",
    icon: "ri-play-circle-line",
    title: "畅快开看",
    desc: "高清秒开不等待，还能离线缓存，通勤路上接着追。",
  },
];